import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-construction-l1',
  templateUrl: './construction-l1.component.html',
  styleUrls: ['./construction-l1.component.scss']
})
export class ConstructionL1Component implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  jobData
  learnerData
  customerServicesEdit


  constructor() { }

  ngOnInit() {
  }





  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of job and learner data", changes);
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);

    }

    if (changes.singleLearner && changes.singleLearner.currentValue && changes.singleLearner.currentValue != undefined) {
      this.learnerData = changes.singleLearner.currentValue
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.customerServicesEdit = changes.assessmentEdit.currentValue
    }

  }

}
